import { render, staticRenderFns } from "./ActivityMonitorEditDialog.vue?vue&type=template&id=88a3bc8e&scoped=true"
import script from "./ActivityMonitorEditDialog.vue?vue&type=script&lang=js"
export * from "./ActivityMonitorEditDialog.vue?vue&type=script&lang=js"
import style0 from "./ActivityMonitorEditDialog.vue?vue&type=style&index=0&id=88a3bc8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a3bc8e",
  null
  
)

export default component.exports